import React from "react"
import i18n from "@/i18n"
import type { GalleryImage } from "./types"
import { getOpenVenuePhotoLabel, getVenuePhotoAlt } from "./types"

const STYLES = {
  button:
    "relative cursor-pointer overflow-hidden border-0 bg-transparent p-0 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2596fa]",
  image: "h-full w-full object-cover",
  overlayContainer: "absolute inset-0 flex items-center justify-center",
  overlayBadge: "rounded-lg bg-neutral-900/90 px-8 py-4 shadow-lg",
  overlayText: "text-base text-white",
} as const

type ImageWithOverlayProps = {
  photo: GalleryImage
  totalCount: number
  onImageClick: (index: number) => void
  className?: string
}

const ImageWithOverlay: React.FC<ImageWithOverlayProps> = ({ photo, totalCount, onImageClick, className = "" }) => {
  const overlayLabel = i18n.t("app.public.venue.gallery.see_all_photos", { count: totalCount })

  return (
    <button
      type="button"
      className={`${STYLES.button} ${className}`}
      onClick={() => onImageClick(2)}
      aria-label={totalCount > 3 ? overlayLabel : getOpenVenuePhotoLabel(2)}
    >
      <img src={photo.url} alt={getVenuePhotoAlt(2)} className={STYLES.image} />
      {totalCount > 3 && (
        <div className={STYLES.overlayContainer}>
          <div className={STYLES.overlayBadge}>
            <span className={STYLES.overlayText}>{overlayLabel}</span>
          </div>
        </div>
      )}
    </button>
  )
}

export default ImageWithOverlay
